import React, {useState, useEffect, useContext} from 'react';
import styles from './Home.module.css';

import {Route, Routes} from 'react-router-dom';

import ConnectWalletHeader from "../header/ConnectWalletHeader";
import LeftPanel from "../LeftPanel/LeftPanel";

import {LayoutGroup} from 'framer-motion';
import Dashboard from "../Dashboard/Dashboard";
import Fleet from "../Fleet/Fleet";
import Account from "../Account/Account";
import {getConfig} from "../../configs/config";
import {SwapMainAppContext} from "../../context/SwapMainAppContext";
import TeleOpSelection from "../TeleOp/TeleOpSelection";
import GlobalLive from "../TeleOp/GlobalLive";
import WhitePaper from "../WhitePaper/WhitePaper";


const Home = () => {

    const [txTrigger, setTxTrigger] = useState(0);

    const [walletAddress, setWalletAddress] = useState(null);

    // Final "confirmed" amount to pass to ConnectWalletHeader
    const [confirmedAmount, setConfirmedAmount] = useState("0");


    const [isWalletLoading, setIsWalletLoading] = useState(true);


    const [UTCTimeTransaction, setUTCTimeTransaction] = useState(null);


    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const [isLeftPanelCollapsed, setIsLeftPanelCollapsed] = useState(false);
    const {
        setUsdtBalance,
        setUsdcBalance,
        showPanel,
        setShowPanel
    } = useContext(SwapMainAppContext);
    // ------------------------ Referral Code Store in local ------------------------
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const referralCode = searchParams.get('ref');

        if (referralCode) {
            localStorage.setItem('referralCode', referralCode);
        }
    }, []);

    useEffect(() => {
        const loadAppConfig = async () => {
            try {
                await getConfig();
            } catch (error) {
                console.error('Error initializing application config from Home component:', error);
            }
        };

        loadAppConfig();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const lastWallet = localStorage.getItem("lastConnectedWallet")
        if (!lastWallet) {
            setIsWalletLoading(false)
        }
    }, []);


    return (
        <LayoutGroup>
            <div
                className={`${styles.outerContainer} ${isLeftPanelCollapsed ? styles.leftPanelCollapsed : ''}`}
                style={{
                    display: "flex",
                    flexDirection: "row",
                    height: '150%',
                    width: '100vw'
                }}
            >

                {/* LEFT PANEL */}
                <LeftPanel
                    walletAddress={walletAddress}
                    onPanelStateChange={setIsLeftPanelCollapsed}
                />
                {/* RIGHT PANEL */}
                <div
                    className={`${styles.rightPanel} ${isLeftPanelCollapsed ? styles.rightPanelExpanded : ''}`}
                    style={{display: "flex", flexDirection: "column"}}
                ><ConnectWalletHeader
                    amount={confirmedAmount}
                    transactionTrigger={txTrigger}
                    onWalletConnected={(publicKey, usdtLeft, usdcLeft) => {
                        setWalletAddress(publicKey);
                        setUsdtBalance(usdtLeft);
                        setUsdcBalance(usdcLeft);
                        setIsWalletLoading(false);
                    }}
                    transactionTime={UTCTimeTransaction}
                    showPanel={showPanel}
                    setShowPanel={setShowPanel}
                />
                    <div className={styles.contentAreaOuter}>

                        <div className={styles.contentArea}>
                            <Routes>
                                <Route path="/" element={<Dashboard/>}/>

                                <Route path="/fleet" element={<Fleet showPanel={showPanel} setShowPanel={setShowPanel}
                                />}/>
                                <Route path="/account" element={<Account/>}/>
                                {/*<Route path="/tele-op" element={<TeleOpSelection/>}/>*/}
                                {/*<Route path='/live-control' element={<GlobalLive/>}/>*/}
                                <Route path='/whitepaper' element={<WhitePaper/>}/>

                            </Routes>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutGroup>
    );
};

export default Home;